module.exports = "<div class=\"page-content\">\n  <router-outlet></router-outlet>\n</div>\n"